module.exports = __webpack_public_path__ + "static/media/tigger_soundi_visoki_3.2c3e4bf8.mp3";